import { fromZonedTime } from 'date-fns-tz';

import { formatDate } from 'lib/helpers/dateUtils';

const CLOCK = /^(\d{1,2}):(\d{2})/;

const isDateLike = (value) =>
  value instanceof Date || (typeof value === 'string' && value.includes('T'));

const instantOf = (value, timezone, date) => {
  if (isDateLike(value)) return new Date(value);
  if (!isDateLike(date)) return new Date();
  const clock = CLOCK.exec(String(value ?? ''));
  if (!clock) return new Date(date);
  const day = formatDate(new Date(date), timezone, 'yyyy-MM-dd');
  return fromZonedTime(`${day}T${clock[1].padStart(2, '0')}:${clock[2]}:00`, timezone);
};

export const getTimezoneLabel = (value, isTimezone, timezone, format = 'zzz', date = null) => {
  if (!isTimezone || !timezone) return;
  return formatDate(instantOf(value, timezone, date), timezone, format);
};
